const e_list = {
  title: "Eidtorials",
  description: "",
  list: [
    {
      ID: "46093",
      post_title: "Jeweled Canvas of Glue-Colour Paintings",
      post_excerpt:
        "Taiwanese artist Huang Hung-chi infuses Western realism techniques with Eastern aesthetics in his glue-colour paintings.\r\n",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/04/Bird-painting-1.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 119,Issue 119,Huang Hung-chi,EC Editorials,Artist,The Talk",
    },
    {
      ID: "46797",
      post_title:
        "Alchemy of Mineral Pigments: A Whispered Ode to Nature's Eternity",
      post_excerpt:
        "Liu Linglie's brushstrokes reveal a symphony of light and shadows as the poet’s soul takes flight",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/08/Chinese-art-7.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 120,Issue 120,Liu Linglie,EC Editorials,Artist,The Talk",
    },
    {
      ID: "46803",
      post_title: "Reviving the Legend of Konoha Tenmoku",
      post_excerpt:
        "Artist Joyce Lin recaptures the ethereal charm of a centuries-old craft with her breakthrough innovations",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/08/tenmoku-3.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 120,Issue 120,Joyce Lin,EC Editorials,Artist,The Talk",
    },
    {
      ID: "46810",
      post_title: "Dancing Between Light and Shadows",
      post_excerpt:
        "Discover how wonders come alive amid Liu Wei Tsen's masterful brushstrokes",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/08/nature-paintings-5.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 120,Issue 120,Liu Wei Tsen,EC Editorials,Artist,The Talk",
    },
    {
      ID: "47216",
      post_title: "The Soulful Artistry of Chiu Su-Mei's Ink Paintings",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/10/Chinese-painting-1.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 121,Issue 121,Chiu Su-mei,EC Editorials,Artist,The Talk",
    },
    {
      ID: "47221",
      post_title: "Immortalizing Childhood Memories within Countless Lines",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/10/traditional-painting-8.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 121,Issue 121,Wandi Zhu,Shun-Wen Chung,EC Editorials,Artist",
    },
    {
      ID: "47224",
      post_title: "Capturing Nature's Tale In Hand-Washed Monochrome Film",
      post_excerpt:
        "With his distinctive perspective and mastery of time-honoured techniques, Taiwanese photographer Chang Chih-huei captures the ephemeral beauty of nature using monochrome film\r\n",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/10/landscape-photography-1.jpg",
      all_categories_name:
        "Traditional Chinese Arts,Eastern Aesthete,Magazine,Featured Right 121,Issue 121,Chang Chih-huei,EC Editorials,Artist,The Talk",
    },
    {
      ID: "47640",
      post_title:
        "Enigmatic Ink: Transforming Cosmic Mysteries into Universal Narratives",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/11/creative-paintings-3.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Beauty of Craftsmanship,I Love Beautiful Art &amp; Décor,Featured Right 122,Issue 122,Sha Ching-Hwa,EC Editorials,Artist,The Talk",
    },
    {
      ID: "47643",
      post_title: "The Beauty of Ink: Silent Landscapes Speak Volumes",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/11/chinese-ink-painting-3.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 122,Issue 122,Chen Shih-Hang,EC Editorials,Artist,The Talk",
    },
    {
      ID: "47649",
      post_title:
        "A Gripping Dichotomy: Western Hyper-Realism Entwines with Eastern Minimalism",
      post_excerpt:
        "Lan Chu-Yueh's artwork brims with imaginative allure, inviting viewers on an infinite voyage of exploration",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/11/nature-paintings-7.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,Magazine,I Love Beautiful Art &amp; Décor,Featured Right 122,Issue 122,Lan Chu-Yueh,EC Editorials,Artist,The Talk",
    },
    {
      ID: "47961",
      post_title: "7 Standout Pieces at Design Miami 2023",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2023/12/Design-Miami-1.jpg",
      all_categories_name:
        "Arts,Artisanship,Traditional Chinese Arts,I Love Beautiful Art &amp; Décor,EC Editorials,Arterior",
    },
    {
      ID: "48039",
      post_title: "8 Great Chinese Ink Paintings Explained",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2024/01/Chinese-Ink-painting-45.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,I Love Beautiful Art &amp; Décor,EC Editorials",
    },
    {
      ID: "48121",
      post_title:
        "Collecting Lacquer Art: Explore Its History, Beauty, and Age-Old Savoir-Faire",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2024/01/Lacquer-art-15.jpg",
      all_categories_name:
        "Arts,Artisanship,Traditional Chinese Arts,Japanese Arts,Eastern Aesthete,I Love Beautiful Art &amp; Décor,EC Editorials",
    },
    {
      ID: "48539",
      post_title: "10 Breathtaking Mountain Paintings: Seeing the Sublime",
      post_excerpt: "",
      extra_image_url:
        "https://magnifissance.com/wp-content/uploads/2024/01/Mountain-paintings-36.jpg",
      all_categories_name:
        "Arts,Traditional Chinese Arts,Eastern Aesthete,I Love Beautiful Art &amp; Décor,EC Editorials",
    },
  ],
};

const getTag = (tag_list) => {
  const str = tag_list;
  const strArray = str.split(",").map((item) => item.trim());
  const filteredItems = strArray.filter(
    (item) => item == "The Talk" || item == "Artist" || item == "Arts"
  );
  const result = filteredItems.join(", ");
  return result;
};

const createTemplate_editorials = (item) => {
  let _tag = getTag(item.all_categories_name);
  let _html = `<div class="eiece_block">
    <a href="https://magnifissance.com/?p=${item.ID}" target="_blank">
      <div class="b_image">
        <img src="${item.extra_image_url}" loading="lazy" />
      </div>
    </a>
    <div class="b_info">
        <div class="b_cate">${_tag}</div>
        <div class="b_title"><a href="https://magnifissance.com/?p=${item.ID}" target="_blank">${item.post_title}</a></div>
        <div class="b_time_tag">
        <div class="b_time">04/24/2023 20:00</div>
        <div class="b_tag">Tradtional Art Selection</div>
        </div>
        <div class="b_desc">${item.post_excerpt}</div>
    </div>
  </div>
  `;
  return _html;
};

const setEditorialsHtml = () => {
  const isFromMag = true;
  if (isFromMag) {
    const url = "https://magnifissance.com/wp-json/custom/v1/editorials";
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (response) => {
        const me_list = response;
        const _ec_editorials = document.getElementById("ec-editorials");
        let _html = "";
        if (me_list && me_list.length > 0) {
          for (const item of me_list) {
            if (item.extra_image_url) {
              const _template = createTemplate_editorials(item);
              _html += _template;
            }
          }
          _ec_editorials.innerHTML = _html;
        } else {
          _ec_editorials.innerHTML = `<div class="f-no-data">No data</div>`;
        }
      });
  } else {
    const me_list = e_list.list;
    const _ec_editorials = document.getElementById("ec-editorials");
    let _html = "";
    if (me_list && me_list.length > 0) {
      for (const item of me_list) {
        if (item.extra_image_url) {
          const _template = createTemplate_editorials(item);
          _html += _template;
        }
      }
      _ec_editorials.innerHTML = _html;
    } else {
      _ec_editorials.innerHTML = `<div class="f-no-data">No data</div>`;
    }
  }
};

setEditorialsHtml();
